<template>
  <div>
    <quill-editor
      ref="myTextEditor"
      :value="value"
      class="editor"
      :options="editorOption"
      @change="onEditorChange($event)"
    ></quill-editor>

    <el-upload
      v-show="false"
      :id="noimg ? 'quill1' : 'quill-upload'"
      name="file"
      :action="baseUrl"
      multiple
      :headers="header"
      list-type="picture"
      :show-file-list="false"
      :before-upload="beforeUpload"
      :on-error="uploadError"
      :on-success="handleExceed"
    >
      <!-- <imgUpload v-on:imgUrl="getImgUrl" :imgLink="caseForm.companyCode"></imgUpload> -->
      <el-button size="small" type="primary"></el-button>
      <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
    </el-upload>
  </div>
</template>

<script>
import "@/assets/css/font.css";
import "@/assets/css/edit.css";
import imgUpload from "./imgUploadNormal.vue";
import utils from "@/jslibs/utils";
import ImageResize from "quill-image-resize-module";
// import { ImageDrop } from 'quill-image-drop-module'
// 引入font.css
import { Quill, quillEditor } from "vue-quill-editor";
var fonts = [
  "SimSun",
  "SimHei",
  "Microsoft-YaHei",
  "KaiTi",
  "FangSong",
  "Arial",
  "Times-New-Roman",
  "sans-serif",
  "宋体",
  "黑体",
];
var Font = Quill.import("formats/font");
Font.whitelist = fonts;
Quill.register(Font, true);
// Quill.register('modules/imageDrop', ImageDrop)
Quill.register("modules/imageResize", ImageResize);

const toolbar = [
  ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
  ["blockquote", "code-block"], // 引用  代码块
  [
    {
      header: 1,
    },
    {
      header: 2,
    },
  ], // 1、2 级标题
  [
    {
      list: "ordered",
    },
    {
      list: "bullet",
    },
  ], // 有序、无序列表
  //   [{ script: "sub" }, { script: "super" }], // 上标/下标
  //   [{ indent: "-1" }, { indent: "+1" }], // 缩进
  // [{'direction': 'rtl'}],                         // 文本方向
  [
    {
      size: ["small", false, "large", "huge"],
    },
  ], // 字体大小
  [
    {
      header: [1, 2, 3, 4, 5, 6, false],
    },
  ], // 标题
  [
    {
      color: [],
    },
    {
      background: [],
    },
  ], // 字体颜色、字体背景颜色
  [
    {
      font: [
        "SimSun",
        "SimHei",
        "Microsoft-YaHei",
        "KaiTi",
        "FangSong",
        "Arial",
        "Times-New-Roman",
        "sans-serif",
        "宋体",
        "黑体",
      ],
    },
  ], // 字体种类
  [
    {
      align: [],
    },
  ], // 对齐方式
  ["clean"], // 清除文本格式
  ["link", "image"], // 链接、图片、视频
]; // 工具菜单栏配置
export default {
  components: {
    quillEditor,
    imgUpload,
  },
  props: ["value", "noimg"],
  data() {
    return {
      updata: {
        source: 50,
      },
      imgBase: "https://train-service-cdn.oss-cn-shenzhen.aliyuncs.com/",
      baseUrl: process.env.VUE_APP_BASE_API + "/v1/common/UploadFile",
      header: {
        "X-Access-Token": utils.getCookie("X-Access-Token") || "",
      },
      content: this.oldcont, // 内容
      quill: Quill,
      uillUpdateImg: false, // 根据图片上传状态来确定是否显示loading动画
      imgUrl: " ", //  上传图片后路径的前缀
      serverUrl: " ", // 上传的图片服务器地址
      editorOption: {
        modules: {
          toolbar: {
            container: toolbar,
            handlers: {
              image: (value) => {
                if (value) {
                  // 给个点击触发Element-ui，input框选择图片文件
                  console.log(this);
                  if (this.noimg) {
                    document.querySelector("#quill1 input").click();
                  } else {
                    document.querySelector("#quill-upload input").click();
                  }
                } else {
                  this.quill.format("image", false);
                }
              },
            },
          },
          // imageDrop: true,
          imageResize: {
            displayStyles: {
              backgroundColor: "black",
              border: "none",
              color: "white",
            },
            modules: ["Resize", "DisplaySize", "Toolbar"],
          },
        },

        placeholder: "", // 提示
        readyOnly: false, // 是否只读
        theme: "snow", // 主题 snow/bubble
        syntax: true, // 语法检测
      },
    };
  },
  watch: {},

  methods: {
    // 值发生变化
    onEditorChange(editor) {
      this.content = editor.html;
      this.$emit("input", editor.html);
    },
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG/PNG 格式!");
        return false;
      }
      // 上传图片之前开启loading
      this.uillUpdateImg = true;
    },
    uploadError() {
      // 图片上传失败,关闭loading
      this.uillUpdateImg = false;
      this.$message.error("图片插入失败");
    },
    handleExceed(res, file, fileList) {
      console.log(res);

      // res为图片服务器返回的数据
      // 获取富文本组件实例
      const quill = this.$refs.myTextEditor.quill;
      console.log(quill);
      // 如果上传成功
      if (res.result) {
        // 获取光标所在位置
        const length = quill.getSelection().index;
        // 插入图片  res.url为服务器返回的图片地址
        quill.insertEmbed(length, "image", this.imgBase + res.result);
        // 调整光标到最后
        quill.setSelection(length + 1);
      } else {
        this.$message.error("图片插入失败");
      }
      // loading动画消失
      this.uillUpdateImg = false;
    },
  },
};
</script>

<style></style>
